import { IMedicine } from "./IpdInterface";
import { ProductInterface, ProductType } from "./ProductInterface";
import { serviceProviderRateUnitType } from "../containers/Calendar/Booking/ServicesSelectWithSpAssign";
import { LabTestGroup } from "./LabInterfaces";

export enum ServiceSessionType {
  single = "single",
  multi = "multi"
}

export interface ServiceInterface {
  id: number;
  name: string;
  resourceCentreId: number;
  grossTotalPrice: number;
  vatPct: number;
  servicePriceExcVAT: number;

  productType: string;
  category: ProductType;
  unit: string;
  active: boolean;
  isMultiSession?: boolean;
  materialCharge: number;
  serviceProviderRateUnits: string;
  serviceProviderId: number | null;
  salesTaxationId?: number | null;
  info: IMedicine;
  productisableId: number;
  productisableName: string;
  bookableServiceId: number | null;
  labCharge: number | null;
  rates: Rates[];
  products: ProductInterface[];
  departmentId?: number;
  salesLedgerId?: number;
  publicBooking: boolean;
  publicDescription?: string;
  instructions?: string;
  referenceId?: number;
  handledByOkhati?: boolean;
  serviceProviderRateUnit: serviceProviderRateUnitType;
  document: {
    products: ProductInterface[];
  };
  labTestGroup?: Partial<LabTestGroup>;
  subType?: string;
}

interface Rates {
  id: number;
  serviceId: number;
  serviceProviderId: number;
  resourceCentreId: number;
  rate: number;
  unit: string | null;
}
